"use strict";
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Office365Api = exports.Office365ApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
// @ts-ignore
const models_1 = require("../models");
// @ts-ignore
const models_2 = require("../models");
/**
 * Office365Api - axios parameter creator
 * @export
 */
const Office365ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ICalendarCreateEventBodyEntity} iCalendarCreateEventBodyEntity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlanningEvent: async (iCalendarCreateEventBodyEntity, options = {}) => {
            // verify required parameter 'iCalendarCreateEventBodyEntity' is not null or undefined
            (0, common_1.assertParamExists)('createPlanningEvent', 'iCalendarCreateEventBodyEntity', iCalendarCreateEventBodyEntity);
            const localVarPath = `/api/office365/createPlanningEvent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCalendarCreateEventBodyEntity, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsers: async (options = {}) => {
            const localVarPath = `/api/office365/getAllUsers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.Office365ApiAxiosParamCreator = Office365ApiAxiosParamCreator;
/**
 * Office365Api -
 */
var Office365Api;
(function (Office365Api) {
    /**
     *
     * @param {ICalendarCreateEventBodyEntity} iCalendarCreateEventBodyEntity
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof Office365Api
     * url /api/office365/createPlanningEvent
     */
    async function createPlanningEvent(iCalendarCreateEventBodyEntity, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.Office365ApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.createPlanningEvent(iCalendarCreateEventBodyEntity, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_1.parseICalendarEvent)(res.data);
            return res;
        });
    }
    Office365Api.createPlanningEvent = createPlanningEvent;
    /**
     *
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof Office365Api
     * url /api/office365/getAllUsers
     */
    async function getAllUsers(options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.Office365ApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getAllUsers(options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_2.parseInlineResponse20012)(res.data);
            return res;
        });
    }
    Office365Api.getAllUsers = getAllUsers;
})(Office365Api || (exports.Office365Api = Office365Api = {}));
